"use client";

import { ReactNode } from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import { FolderKanban, Inbox, LogOut, MessageSquare, Plus } from "lucide-react";
import { Button, useAuth } from "@vionixasia/shared-components";

export function AdminShell({ children }: { children: ReactNode }) {
  const { user, loading, logout } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="flex min-h-screen items-center justify-center text-sm text-muted">Loading...</div>;
  }

  const isAdmin = user?.role === "admin" || user?.role === "superadmin" || user?.isAdmin === true;
  if (!user || !isAdmin) {
    const next = `${location.pathname}${location.search}`;
    return <Navigate to={`/login?continue=${encodeURIComponent(next)}`} replace />;
  }

  return (
    <div className="min-h-screen bg-surface">
      <aside className="fixed inset-y-0 left-0 hidden w-64 border-r border-line bg-white px-5 py-6 lg:block">
        <Link to="/dashboard/overview" className="flex items-center gap-3 text-lg font-semibold text-ink">
          <span className="flex h-9 w-9 items-center justify-center rounded bg-brand text-white">
            <MessageSquare size={18} />
          </span>
          WhatsApp Engine
        </Link>
        <nav className="mt-8 space-y-2 text-sm">
          <Link className="flex items-center gap-2 rounded-xl px-3 py-2 text-ink hover:bg-surface" to="/dashboard/projects">
            <FolderKanban size={16} /> Projects
          </Link>
          <Link className="flex items-center gap-2 rounded-xl px-3 py-2 text-ink hover:bg-surface" to="/dashboard/projects/new">
            <Plus size={16} /> Create Project
          </Link>
          <Link className="flex items-center gap-2 rounded-xl px-3 py-2 text-muted hover:bg-surface" to="/dashboard/projects">
            <Inbox size={16} /> Inbox by Project
          </Link>
        </nav>
        <Button
          variant="ghost"
          color="slate"
          className="absolute bottom-6 left-5"
          onClick={() => logout()}
        >
          <LogOut size={16} /> Logout
        </Button>
      </aside>
      <main className="lg:pl-64">
        <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">{children}</div>
      </main>
    </div>
  );
}
